import api from './api';

export function getOne(id) {
    return api.get(`/users/${id}`);
}

export function saveAccount(params) {
    return api.put(`/users/${params.id}`, params);
}

export function search(searchText, params) {
    return api.get(`/users/search`, { params: { ...params, q: searchText } });
}

export function register(params) {
    return api.post('/register', params);
}

export function sendPasswordReset(params) {
    return api.post('/send-password-reset', params);
}

export function resetPassword(params) {
    return api.post('/reset-password', params);
}

export function remove(userId) {
    return api.delete(`/users/${userId}`);
}

export function authenticateAsUser(userId) {
    return api.post(`/authenticate-as-user/${userId}`);
}